import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class MediaTypeField extends BaseOption {
  static userInterfaceComponent = {
    label: "Media Type Field",
    component: inspectorTools.SIMPLE_INPUT,
    descriptionMessage: "Field on the bound entity naming the accepted media type",
  };

  static defaultValue = "";
}
